import type {
    AxiosRequestConfig,
    AxiosRequestHeaders
} from 'axios';
import axios from 'axios';


export function createAxiosHeaders() {
    const output: AxiosRequestHeaders = {};

    return output;
}

/**
 * Get headers object from old axios version.  If this object is nullish,
 * a new empty object will be created.
 *
 * @param headers
 * @returns {AxiosRequestHeaders}
 */
function toAxiosHeadersLegacy(headers: AxiosRequestConfig['headers']): AxiosRequestHeaders {
    return headers ?? {};
}


/**
 * Get an AxiosHeaders object from the headers defined in a request config.
 * If this is already an AxiosHeaders object, it will be returned as-is.
 * Otherwise, a new AxiosHeaders object will be created containing the
 * contents of the previous headers object, if applicable.
 *
 * @param headers
 * @returns
 */
function toAxiosHeadersModern(headers: AxiosRequestConfig['headers']): AxiosRequestHeaders {
    if (
        // @ts-ignore
        headers instanceof axios.AxiosHeaders
        || (
            headers
            // @ts-ignore
            && (headers as any)[Symbol.toStringTag] === axios.AxiosHeaders.name
            )
     ) {
        // @ts-ignore
        return headers as axios.AxiosHeaders;
    }

    if (!headers) {
        // @ts-ignore
        return new axios.AxiosHeaders();
    }

    if (Object.keys(headers).length === 0) {
        // @ts-ignore
        return new axios.AxiosHeaders();
    }

    // "Content-Type" does not allow arbitrary strings, and therefore,
    // TypeScript complains when we try to pass `requestOptions.headers`
    // into the constructor of `AxiosHeaders`, _even though_ it is
    // very much allowed input.  Therefore, we shut it up here.

    // @ts-ignore
    const output = new axios.AxiosHeaders(
        // @ts-ignore
        headers
    );

    return output;
}

export const toAxiosHeaders =
    !(
        // The class AxiosHeaders doesn't exist in
        // older versions of axios.  If it doesn't
        // exist, we use the legacy version.
        // If it does, we use the new version.

        // @ts-ignore
        axios.AxiosHeaders
    )
        ? toAxiosHeadersLegacy
        : toAxiosHeadersModern;

export function getOrCreateHeaders(config: AxiosRequestConfig) {
    const headers = toAxiosHeaders(config.headers);
    config.headers = headers;

    return headers;
}